export default __webpack_public_path__ + "static/media/Emina Gudić.05dc0e20.jpg";